module.exports = __webpack_public_path__ + "img/company-seal.7c91b833.png";